export default __webpack_public_path__ + "static/media/confectionists-confectionist.cefb788c.svg";